import React, { useState, useEffect } from 'react'
import EmptyState from '../../elements/EmptyState'
import { unSlugify } from '../../../utils'
import ModalDialog from '../../layouts/ModalDialog';
import UpdateStudentMedicals from './UpdateStudentMedicals';
import { useDispatch, useSelector } from 'react-redux';
import { clearUpdatedStudent } from '../../../store/actions/studentsActions';
import { updateStudent } from '../../../store/actions/studentsActions';
import { SET_SUCCESS } from '../../../store/types';

// medical?: {
//   bloodGroup: string
//   allergies: string[],
//   preExistingConditions: {
//       conditions: string[]
//       details: string
//   },
//   inoculations: {
//       type: string,
//       other?: string,
//       date: Date
//   }[]
// }


const StudentMedicals = ({student, reload}) => {
  const [updatingMedicals, setUpdatingMedicals] = useState(false);
  const dispatch = useDispatch()
  const studentsSelector = useSelector(state => state.students)
  useEffect(() => {
    if(studentsSelector.updatedStudent){
      reload()
      dispatch({
        type: SET_SUCCESS,
        payload: 'student medicals updated successfully!'
      })
      dispatch(clearUpdatedStudent())
      setUpdatingMedicals(false)
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [student, studentsSelector.updatedStudent])
  return (
    <>
      <div className='w-full'>
        <div className='w-full xl:flex items-start justify-between'>
          <div className='w-full xl:w-1/2'>
            <p className='uppercase tracking-[0.2em] text-sm text-vcm-purple'>Student Medicals</p>
            <p className='text-sm mt-[5px]'>Medical Information for this student. You can edit this whenever needed when you click on "Update medicals"</p>
          </div>
          <button onClick={()=>{setUpdatingMedicals(true)}} className='bg-vcm-purple w-full xl:w-max mt-[20px] mb-[20px] xl:mt-0 px-[18px] py-[12px] rounded-[8px] text-vcm-light-purple text-sm hover:bg-black transition duration-200'>
            Update Medicals
          </button>
        </div>

        <div className='mt-[20px]'>
          {!student.medical ? 
            <div>
              <EmptyState emptyStateText={`No medical information provided for this student yet. Click on the "Update medicals" button above to provide information`} />
            </div>

            :
            <>
              <div className='w-full'>
                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>blood group</label>
                <p className='text-gray-600'>{student.medical.bloodGroup ? student.medical.bloodGroup : <span className='text-gray-400 text-sm'>Not provided</span> }</p>
              </div>

              <div className='w-full mt-4'>
                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Pre-existing medical conditions</label>
                <p className='text-gray-600'>{student.medical?.preExistingConditions?.conditions?.length > 0 ? student.medical.preExistingConditions?.conditions?.join(', ') : <span className='text-gray-400 text-sm'>No pre-existing conditions indicated for this student</span> }</p>
              </div>

              <div className='w-full mt-4'>
                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Allergies</label>
                <p className='text-gray-600'>{student.medical?.allergies?.length > 0 ? student.medical.allergies.join(', ') : <span className='text-gray-400 text-sm'>No allergies indicated for this student</span> }</p>
              </div>

              <div className='w-full mt-4'>
                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Inoculations</label>
                <div className='w-full flex flex-wrap xl:flex-nowrap items-center gap-x-[10px]'>
                  {student.medical.inoculations && student.medical.inoculations.length > 0 ?student.medical.inoculations.map((inoculation, inoculationIndex)=>(
                    <div key={inoculationIndex} className='px-[15px] py-[7px] mb-[7px] bg-gray-100 rounded'>
                      <p className='text-gray-600 text-sm capitalize'>
                        {unSlugify(inoculation.type)}
                      </p>
                      <p className='text-xs text-gray-500'>{new Date(inoculation.date).toDateString()}</p>
                    </div>
                  ))
                  :
                    <p className='text-gray-400 text-sm'>No inoculation information provided for this student yet</p>
                  }
                </div>
              </div>
            </>
          }
        </div>

      </div>

      <ModalDialog
        shown={updatingMedicals} 
        closeFunction={()=>{setUpdatingMedicals(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Update medical information for ${student?.firstName} ${student.lastName}`}
        maxWidthClass='max-w-3xl'
        hideActions={true}
      >
        <UpdateStudentMedicals
            medicals={student?.medical || {}}
            reload={()=>reload()}
            closeFunction={()=>{setUpdatingMedicals(false)}} 
            submitMedicals={(payload) => {dispatch(updateStudent(student._id, {medical: payload}))}}
        />

      </ModalDialog>
    </>
  )
}

export default StudentMedicals